import { DeviceTokenHelper } from '@/lib/helpers/device-token.helper'
import {
  TAddressBody,
  TAutoCompleteAddressParams,
  TAutoCompleteAddressResponse,
} from '@/types/address'
import {
  THistoryPointCoolCashParams,
  TPointHistory,
  TVoucherWalletItem,
} from '@/types/club'
import {
  TCheckExistPhoneResponse,
  TDeleteAccountConfirmData,
  TDeleteAccountInitiateData,
  TGenerateReferralCode,
  TIndexReferFriend,
  TReviewBody,
  TReviewsParams,
  TReviewsResponse,
  TSaveVoucherResponse,
  TUpdateInfoBody,
} from '@/types/customer'
import { ApiResponse, httpClient } from './http-client'

export class __cAccountService {
  static async getHistoryPointCoolCash(params?: THistoryPointCoolCashParams) {
    const response = await httpClient.V3.get<ApiResponse<TPointHistory[]>>(
      `/coolclub-member/history-points`,
      {
        params,
      }
    )

    return response
  }
  static async getVoucherWallet(params?: { device_token: string }) {
    const response = await httpClient.V3.get<ApiResponse<TVoucherWalletItem[]>>(
      `/voucher-wallet`,
      {
        params,
      }
    )

    return response
  }

  static async updateAddress(id: string, body: TAddressBody) {
    const response = await httpClient.V1.post(`/account/addresses/${id}`, body)
    return response
  }

  static async createAddress(body: TAddressBody) {
    const response = await httpClient.V1.post(`/account/addresses`, body)
    return response
  }

  static async removeAddress(id: string) {
    const response = await httpClient.V1.post(`/account/addresses/${id}/delete`)
    return response
  }

  static async autoCompleteAddress(
    params: TAutoCompleteAddressParams,
    config?: { signal?: AbortSignal }
  ) {
    const response = await httpClient.V1.get<TAutoCompleteAddressResponse>(
      `/place-autocomplete`,
      {
        params: {
          ...params,
          device_token: DeviceTokenHelper.get(),
        },
        signal: config?.signal,
      }
    )
    return response
  }

  static async getReviews(params: TReviewsParams) {
    const response = await httpClient.V1.get<TReviewsResponse>(
      `/account/reviews`,
      {
        params,
      }
    )

    return response
  }

  static async createReview(body: TReviewBody) {
    const response = await httpClient.V1.post('/reviews', body)
    return response
  }

  static async getIndexReferFriend() {
    const response =
      await httpClient.V3.get<ApiResponse<TIndexReferFriend>>(
        `/customers/referral`
      )

    if (response?.data && !response.data?.referral_code) {
      const { data: generateResponse } = await this.generateReferralCode()
      if (generateResponse?.discount_title) {
        response.data.referral_code = generateResponse.discount_title
      }
    }
    return response
  }

  static async updateInfo(body: TUpdateInfoBody) {
    const response = await httpClient.V1.post('/account/update', body)
    return response
  }

  static async checkExistPhone(phone: string) {
    const response = await httpClient.V3.get<TCheckExistPhoneResponse>(
      `/account/check-phone-exist/${phone}`
    )
    return response
  }

  static async saveVoucher(code: string) {
    const response = await httpClient.V3.post<TSaveVoucherResponse>(
      `/voucher-wallet`,
      {
        code,
      }
    )

    return response
  }

  static async generateReferralCode() {
    const response = await httpClient.V3.post<
      ApiResponse<TGenerateReferralCode>
    >(`/customers/generate-referral-code`)
    return response
  }

  // Khởi tạo yêu cầu xóa tài khoản, trả về session_uuid + snapshot (coolcash, đơn hàng)
  // để hiển thị ở bước 1 của luồng xóa tài khoản
  static async initiateAccountDeletion() {
    const response = await httpClient.V4_NEW.post<
      ApiResponse<TDeleteAccountInitiateData>
    >('/account/deletion/initiate')
    return response
  }

  // Xác nhận xóa tài khoản sau khi đã verify OTP thành công ở bước trước
  static async confirmAccountDeletion(sessionUuid: string) {
    const response = await httpClient.V4_NEW.post<
      ApiResponse<TDeleteAccountConfirmData>
    >('/account/deletion/confirm', {
      session_uuid: sessionUuid,
    })
    return response
  }
}
